module.exports = __webpack_public_path__ + "img/dls-csb.5012cd65.png";